"use strict";

angular.module("customer")
.service("UserCustomerService", function($resource, appConfig, UserService) {
    var queryResource = $resource(appConfig.API_SERVER + "/auth/customer/user-customers/", {}, {
        query: {
            method: "get",
            isArray: false
        }
    });
    var chooseResource = $resource(appConfig.API_SERVER + "/auth/customer/user-customers/:id/choose/", {id: "@id"}, {
        update: {
            method: "PUT"
        }
    });
    var releaseResource = $resource(appConfig.API_SERVER + "/auth/customer/user-customers/release/", {}, {
        update: {
            method: "PUT"
        }
    });

    this.query = function(params) {
        return queryResource.query(params);
    };

    this.choose = function(userCustomerId) {
        return chooseResource.update({id: userCustomerId});
    };

    this.release = function() {
        return releaseResource.update().$promise.then(function onSuccess() {
            return UserService.refreshCurrentUser();
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-customer/user-customer.service.js
// module id = 942
// module chunks = 0